/**
 * @file コンポーネント：フル動画ページお気に入りボタン DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledButton } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    return (
        <StyledButton
            className={props.isFavorite && "is-favorite"}
            onClick={() => props.fnOnClickButton()}
            title={
                props.isFavorite
                    ? localized["Label.FavoriteRemove"]
                    : localized["Label.FavoriteAdd"]
            }
        >
            {props.isFavorite ? (
                // お気に入り登録済み
                <i className="fas fa-star"></i>
            ) : (
                // お気に入り未登録
                <i className="far fa-star"></i>
            )}
        </StyledButton>
    );
};
